import { render, staticRenderFns } from "./copyRight.vue?vue&type=template&id=d47eb706&scoped=true&"
import script from "./copyRight.vue?vue&type=script&lang=js&"
export * from "./copyRight.vue?vue&type=script&lang=js&"
import style0 from "./copyRight.vue?vue&type=style&index=0&id=d47eb706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47eb706",
  null
  
)

export default component.exports